import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import ModalLayout from "@layouts/modal";
import {UserContext} from "@providers/user";
import {realtorContactInfo} from "@models/user";
import {agencyContactInfo} from "@models/agency";
import StatusGif from "@atoms/status_gif";
import CircleLoading from "@molecules/lotties/circle_loading";
import usePrevious from "@hooks/previous";
import {isEmpty} from "@helpers/helpers";
import {getPropertyContactInfo} from "@models/property";
import {useWindowSize} from "@helpers/windows.size";
import ContactContent, {handlePhoneNumbers} from "./contact_content";
import ContactReviews from "./contact_reviews";
import ContactAssignedRealtor from "./contact_assigned_realtor";
import Icon from "@atoms/icon";
import ButtonTransparent from "../../atoms/button.transparent";
import {ContactEvents} from "@helpers/google_tag_events";
import CrmPropertyRequestForm from "../property/crm_requests/crm_property_request_form";
import {handleShowCrmModalTrack, handleSubmitTrack} from "../property/crm_requests/crm_requests_track";
import PreContactRequest from "./pre_contact_request";
import {storePropertyCallRequest} from "../../../models/property";
import {checkShowPreContactRequestByCity} from "./helpers";
import ArrowRightIcon from '@icons/arrow-right.svg';


const ContactInfoModal = ({perContact, setPerContact, setQuickContact, defaultContactInfo = null, setShowLoginWithCallback}) => {
    const windowWidth = useWindowSize();
    const userContext = React.useContext(UserContext);

    const {show, property_id, city_id, district_id, realtor_id, agency_id, isOnList, isAssignedProperty, exists_in_kanban, isBadeSaba} = perContact;
    const crmTrackPage = (!isEmpty(isOnList) && isOnList) ? 'on_lists' : (isOnList === false ? 'on_property_show' : '');

    const prePropertyId = usePrevious(property_id);
    const [contactInfo, setContactInfo] = useState(null);
    const [reviewsShow, setReviewsShow] = useState(false);
    const [selectedRate, setSelectedRate] = useState(0);
    const [showActionStatus, setShowActionStatus] = useState({text: '', status: ''});
    const [hideAssignedRealtorsBox, setHideAssignedRealtorsBox] = useState(false);
    const [notAssignedRealtors, setNotAssignedRealtors] = useState(false);
    const [preContactRequestShow, setPreContactRequestShow] = useState(false);

    function setContact(result) {
        setContactInfo(result.contactInfo);

        if (!isEmpty(result.contactInfo)) {
            const numbers = handlePhoneNumbers(result.contactInfo, true);

            if (numbers.length && !isEmpty(setQuickContact)) {
                setQuickContact({show: true, phone: numbers[0]})
            }
        }
    }

    function getPropertyContact() {
        setHideAssignedRealtorsBox(true);
        setNotAssignedRealtors(true);

        getPropertyContactInfo(property_id).then(result => {
            // Google Tag Manager Custom Event Trigger for contact
            const isPropertyList = (!isEmpty(perContact['isOnList']) && perContact['isOnList']);
            ContactEvents(isPropertyList);

            setContact(result);
        }).catch(error => {
            console.log(error)
        });
    }

    const handleContactInfo = () => {
        if (isEmpty(exists_in_kanban) || !exists_in_kanban) {
            if (!isEmpty(property_id) && (isEmpty(isAssignedProperty) || !isAssignedProperty)) {
                getPropertyContact();
            } else if (!isEmpty(realtor_id)) {
                realtorContactInfo(realtor_id).then(result => {
                    // Google Tag Manager Custom Event Trigger for contact
                    ContactEvents();

                    setContact(result);
                }).catch(error => {
                    console.log(error)
                });
            } else if (!isEmpty(agency_id)) {
                agencyContactInfo(agency_id).then(result => {
                    // Google Tag Manager Custom Event Trigger for contact
                    const isPropertyList = (!isEmpty(perContact['isOnList']) && perContact['isOnList']);
                    ContactEvents(isPropertyList);


                    setContact(result);
                }).catch(error => {
                    console.log(error)
                });
            }
        }
    };

    useEffect(() => {
        setContactInfo(defaultContactInfo);
        setReviewsShow(false);
    }, [defaultContactInfo]);

    useEffect(() => {

        if (show && exists_in_kanban) {
            handleShowCrmModalTrack(city_id, crmTrackPage);
        }

        setContactInfo(null);

        setReviewsShow(false);
        setSelectedRate(0);
        setHideAssignedRealtorsBox(false);
        setShowActionStatus({text: '', status: ''});

        let getContact = true;
        let authUserIsNormalUser = true;
        if (userContext.check && !userContext.isNormalUser) {
            authUserIsNormalUser = false;
        }

        if (authUserIsNormalUser && !exists_in_kanban && checkShowPreContactRequestByCity(city_id)) {
            let checkSetPreContactRequest = localStorage.getItem('pre_contact_request_number');

            if (userContext.check) {
                const {mobile, mobile2} = userContext.contacts();

                if (!isEmpty(mobile)) {
                    checkSetPreContactRequest = mobile;
                } else if (!isEmpty(mobile2)) {
                    checkSetPreContactRequest = mobile2;
                }
            }

            if (!isEmpty(checkSetPreContactRequest)) {
                setPreContactRequestShow(false);
                getContact = true;

                const data = {
                    property_id: property_id,
                    //name: fields.name.value,
                    mobile: checkSetPreContactRequest,
                    captcha_code: '',
                    source: (isBadeSaba ? 'badesaba' : '2nabsh'),
                    mode: 'contact'
                };

                if (!isEmpty(property_id)) {
                    storePropertyCallRequest(data).then(async (result) => {
                        localStorage.setItem('pre_contact_request_number', data.mobile);

                        handleSubmitTrack(city_id, crmTrackPage, 'contact');
                    }).catch(err => {

                        if (!isEmpty(err.response) && !isEmpty(err.response.data)) {
                            const response = err.response.data;
                            let hasError = false;

                            getContact = false;

                            setPreContactRequestShow(true);
                        }
                    });
                }
            } else {
                setPreContactRequestShow(true);
                getContact = false;
            }
        } else {
            setPreContactRequestShow(false);
        }

        if (getContact && show && (property_id !== null && (property_id !== prePropertyId || isEmpty(contactInfo))) || !isEmpty(realtor_id) || !isEmpty(agency_id)) {
            handleContactInfo();
        }
    }, [show]);

    const handleSelectRate = (rate) => {
        setReviewsShow(true);
        setSelectedRate(rate);
    };

    let modalTitle = 'اطلاعات تماس';

    if (isEmpty(exists_in_kanban) || !exists_in_kanban) {
        if (!isEmpty(isAssignedProperty) && isAssignedProperty && !hideAssignedRealtorsBox) {
            modalTitle = 'مشاورین این ملک';
        }

        if (!isEmpty(contactInfo) && !isEmpty(contactInfo.agency_id) && !isEmpty(contactInfo.agency_name)) {
            modalTitle = 'تماس با دفتر';
        } else if (!isEmpty(contactInfo) && !isEmpty(contactInfo.realtor_id) && !isEmpty(contactInfo.realtor_name)) {
            modalTitle = 'تماس با مشاور';
        }
    }

    if (exists_in_kanban) {
        modalTitle = 'کد آگهی : ' + property_id;
    }

    return (
        <ModalLayout
            show={show}
            setShow={(val) => setPerContact({show: val, property_id: property_id})}
            modalDialogClass={"modal-sm contact-modal " + ((show && reviewsShow && selectedRate <= 4 && isEmpty(showActionStatus.status)) ? 'show-reviews' : '')}
            dialogBodyClassName="px-0"
            scrollable={(windowWidth < 768)}
        >
            <Container className="h-100">
                {
                    (!isEmpty(exists_in_kanban) && exists_in_kanban && !isEmpty(property_id)) ?
                        <Body className="text-center">
                            <h3 className="h2">
                                {modalTitle}
                            </h3>

                            <div className="text-right mt-24">
                                <CrmPropertyRequestForm
                                    authName={(userContext.check) ? userContext.getName : ''}
                                    authMobile={(userContext.check) ? userContext.user.mobile : ''}
                                    page={crmTrackPage}
                                    property_id={property_id}
                                    city_id={city_id}
                                    district_id={district_id}
                                    isBadeSaba={isBadeSaba}/>
                            </div>
                        </Body>
                        :
                        <React.Fragment>
                            {
                                (isEmpty(showActionStatus.status)) ?
                                    <React.Fragment>

                                        {
                                            (!hideAssignedRealtorsBox && isAssignedProperty) ?
                                                <ContactAssignedRealtor
                                                    property_id={property_id}
                                                    perContact={perContact}
                                                    setContact={setContact}
                                                    getPropertyContact={getPropertyContact}
                                                    setHideAssignedRealtorsBox={setHideAssignedRealtorsBox}
                                                    setNotAssignedRealtors={setNotAssignedRealtors}
                                                />
                                                :
                                                <Body className={"text-center " + ((selectedRate > 0 && reviewsShow) ? 'position-absolute' : 'position-relative')}>

                                                    <h3 className="h2">
                                                        {modalTitle}
                                                    </h3>

                                                    {
                                                        (isAssignedProperty && !notAssignedRealtors) ?
                                                            <Back className="icon-btn" onClick={() => setHideAssignedRealtorsBox(false)}>
                                                                <Icon width="16" height="16"><ArrowRightIcon/></Icon>
                                                            </Back>
                                                            : ''
                                                    }

                                                    {
                                                        (preContactRequestShow) ?
                                                            <PreContactRequest
                                                                page={crmTrackPage}
                                                                property_id={property_id}
                                                                city_id={city_id}
                                                                isBadeSaba={isBadeSaba}
                                                                setPreContactRequestShow={setPreContactRequestShow}
                                                                handleContactInfo={handleContactInfo}
                                                                authName={(userContext.check) ? userContext.getName : ''}
                                                                authMobile={(userContext.check) ? userContext.user.mobile : ''}
                                                            />
                                                            :
                                                            (
                                                                (!isEmpty(contactInfo)) ?
                                                                    <ContactContent
                                                                        property_id={property_id}
                                                                        contactInfo={contactInfo}
                                                                        selectedRate={selectedRate}
                                                                        handleSelectRate={handleSelectRate}
                                                                    />
                                                                    :
                                                                    <div className="mt-32" style={{height: 80}}>
                                                                        <CircleLoading width={56} height={56}/>
                                                                    </div>
                                                            )
                                                    }
                                                </Body>
                                        }

                                        <ContactReviews
                                            reviewsShow={reviewsShow}
                                            contactInfo={contactInfo}
                                            selectedRate={selectedRate}
                                            setReviewsShow={setReviewsShow}
                                            setSelectedRate={setSelectedRate}
                                            setShowActionStatus={setShowActionStatus}
                                            setShowLoginWithCallback={setShowLoginWithCallback}
                                        />
                                    </React.Fragment>
                                    :
                                    <div className="px-24 pb-40 pb-md-0 px-md-32 text-center">
                                        <h3 className="h2">ثبت رای</h3>
                                        <StatusGif className="" text={showActionStatus.text} status={showActionStatus.status}/>
                                    </div>
                            }
                        </React.Fragment>
                }
            </Container>
        </ModalLayout>
    );
};

export default ContactInfoModal;

// styles

const Container = styled.div`
    overflow: hidden;
    position: relative;
`;

const Body = styled.div`
    display: block;
    padding: 0 32px;
    width: 100%;
    height: 100%;
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        padding: 0 24px 40px;
    }
`;

const Back = styled(ButtonTransparent)`
    display: flex;
    position: absolute;
    top: 8px;
    right: 32px;
    padding: 0;
    
    .icons { 
        width: 24px;
        max-width: 24px;
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        right: 24px;
    }
`;